import { apiConfig } from "@/api/AppApi/config";
import { useMutation } from "@tanstack/react-query";
import Reminder from "./reminder";

const reminder = new Reminder(apiConfig());

export const useRemindMe = (props?: {
  onSuccess?: (res: any) => void;
  onError?: (x: any) => void;
}) => {
  return useMutation(
    (data: {
      type: "whatsapp" | "email";
      email: string;
      product: number;
      mobile: string;
    }) =>
      data.type === "email"
        ? reminder.remindEmail(data)
        : reminder.remindPhone(data),
    {
      onSuccess: props?.onSuccess,
      onError: props?.onError,
    },
  );
};
